import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <div className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-8 md:space-y-0">
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-lg">
                <i className="ri-water-flash-line text-white"></i>
              </div>
              <span className="text-xl font-bold">SIENG</span>
            </div>
            <p className="text-gray-400">
              지속 가능한 미래를 위한 <br />
              스마트 물 관리 솔루션
            </p>
          </div>

          <div className="flex flex-col md:flex-row md:items-top md:justify-between space-y-6 md:space-y-0 md:space-x-8">
            <div className="text-sm w-full md:w-80">
              <h4 className="font-semibold mb-4 text-center md:text-left">
                기업정보
              </h4>
              <ul className="space-y-2 text-gray-400 text-center md:text-left">
                <li>에스아이이엔지 | 대표 | 곽현곤</li>
                <li className="break-words">
                  강원도 삼척시 중앙로346, 본관동 304(교동)
                </li>
                <li>sieng2018@naver.com</li>
                <li>사업자등록번호 556-04-00971</li>
              </ul>
            </div>

            <div className="text-sm w-full md:w-auto h-full">
              <h4 className="font-semibold mb-4 text-center md:text-left">
                기능
              </h4>
              <ul className="space-y-2 text-gray-400 text-center md:text-left">
                <li>
                  <button className="hover:text-white cursor-pointer whitespace-nowrap">
                    <Link to="http://211.170.168.194/">
                      이전 홈페이지로 이동하기
                    </Link>
                  </button>
                </li>
                <li>
                  <button className="hover:text-white cursor-pointer whitespace-nowrap">
                    API
                  </button>
                </li>
                <li>
                  <button className="hover:text-white cursor-pointer whitespace-nowrap">
                    고객센터
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 에스아이이엔지. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
